import { useReactiveVar } from "@apollo/client";
import { MainWrapper, ThemeWrapper } from "@flixbus/honeycomb-react";
import {
  NavigationApp,
  ErrorBoundary,
  Notification,
  Navigation,
  isDarkThemeVar,
  isTestEnv,
  AuthProvider,
  StateProvider,
  TranslationProvider,
} from "@flixbus-phx/marketplace-common";
import * as React from "react";
import { BrowserRouter } from "react-router-dom";
import Router from "./router/Router";
import Layout from "./ui/Layout";
import "normalize.css/normalize.css";

export const AppContent: React.FC = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <StateProvider fetchPolicy="cache-and-network">
          <MainWrapper full>
            <Navigation app={NavigationApp.MUS} isUsedInternal />
            <Layout>
              <Router />
            </Layout>
          </MainWrapper>
          <Notification />
        </StateProvider>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

const App: React.FC = () => {
  const isDarkTheme = useReactiveVar(isDarkThemeVar);

  // User is Cypress
  if (isTestEnv() && process.env.NODE_ENV !== "production") {
    return (
      <ThemeWrapper theme="flix" style={{ minWidth: "1200px" }}>
        <TranslationProvider usesCookies isUsedInternal>
          <AppContent />
        </TranslationProvider>
      </ThemeWrapper>
    );
  }

  return (
    <ThemeWrapper id="theme-wrapper" dark={isDarkTheme}>
      <TranslationProvider usesCookies isUsedInternal>
        <AuthProvider>
          <AppContent />
        </AuthProvider>
      </TranslationProvider>
    </ThemeWrapper>
  );
};

export default App;
